// components/navbar/NavAuth.js
import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const NavAuth = ({ isMobile }) => {
  const { isLoggedIn, logout, user } = useAuth(); // Add user to destructured values
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  // Apply different class for desktop vs mobile view
  const authClassName = isMobile ? "auth-section" : "auth-section desktop-auth";

  return (
    <div className={authClassName}>
      {isLoggedIn ? (
        <>
          <NavLink to="/profile" className="profile-button-circle">
            {user?.profilePicture ? (
              <img 
                src={user.profilePicture} 
                alt="Profile" 
                className="profile-picture"
              />
            ) : (
              <span className="profile-icon-fallback">
                {user?.name?.charAt(0).toUpperCase() || "U"}
              </span>
            )}
          </NavLink>
          <button onClick={handleLogout} className="logout-button">
            Logout
          </button>
        </>
      ) : (
        <>
          <NavLink to="/login" className="auth-button">
            Login
          </NavLink>
          <NavLink to="/signup" className="auth-button signup-button">
            Sign Up
          </NavLink>
        </>
      )}
    </div>
  );
};

export default NavAuth;